import styled from 'styled-components/macro';

// eslint-disable-next-line import/no-cycle
import {useSelector} from "react-redux";
import {useState} from "react";
import {useLoggedIn, useModal, useRelativeTime} from "../store";
import {NO_VOTE} from "../utils/votes";
import {useFeedback} from "../store/feedback";
import {usePost, usePostVote} from "../api/post";
import {selectPostVoteState} from "../store/selectors";
import {decodeBase62} from "../utils/base62";
import {PostVote} from "./vote";
import CommunityLogo from "./community_logo";
import NavLink from "./nav_link";
import Signup from "./signup";
import {themecolors} from "../utils/themecolors";

const Main = styled.div``;
const Title = styled.div``;
const Posted = styled.div``;
const Community = styled.span``;
const Separator = styled.span``;
const Content = styled.div``;
const Comments = styled.div``;
const Preview = styled.div``;

const PostEmbed = styled(({className, uuid}) => {
    const modal = useModal();
    const {feedbackCh} = useFeedback();
    const id = decodeBase62(uuid);
    const {post} = usePost(feedbackCh, id)
    const ago = useRelativeTime(post?.created, false);
    const loggedIn = useLoggedIn();
    const vote = usePostVote(feedbackCh);
    const voteValue = useSelector(selectPostVoteState(post?.id));
    const [voteDir, setVoteDir] = useState(NO_VOTE);
    const handleVote = async (dir) => {
        if (!loggedIn) {
            modal.open(Signup);
        } else {
            if (dir !== voteValue) {
                setVoteDir(dir);
            }
            try {
                await vote(post, dir);
            } catch {
                setVoteDir(NO_VOTE);
            }
        }
    };
    return (
        <div className={className}>
            {post &&
            <Main>
                <PostVote
                    onVote={handleVote}
                    vote={voteValue}
                    score={post?.score}
                    up={post?.score_up}
                    down={post?.score_down}
                    animate={voteDir}
                />
                <Content>
                    <Posted>
                        <CommunityLogo name={post?.community}/>
                        <Community>
                            <NavLink href={`/c/${post?.community}`}>{post?.community}</NavLink>
                        </Community>
                        <Separator>• </Separator>
                        <span><NavLink href={`/u/${post?.author}/`}>{post?.author}</NavLink></span>
                        <Separator>• </Separator>
                        <span>{ago}</span>
                    </Posted>
                    <Title>
                        <NavLink href={`/p/${post?.uuid}/`}>
                            {post?.title}
                        </NavLink>
                    </Title>
                    <Comments>
                        <NavLink href={`/p/${post?.uuid}/`}>
                            {post?.comments} comments
                        </NavLink>
                    </Comments>
                </Content>
                {post?.preview &&
                    <Preview>
                        <img src={post.preview} />
                    </Preview>
                }
            </Main>
            }
        </div>
    );
})`
  ${Main} {
    width: 100%;
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_5 : themecolors.lighter_border};
    border-radius: 12px;
    font-size: 14px;
    padding: 12px 18px;
    display: flex;
  }
  ${Posted} {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    white-space: nowrap;
    flex-wrap: wrap;
  }
  ${Posted} img {
    height: 20px;
    margin-right: 6px;
    border-radius: 50%;
  }
  ${Community} {
    font-weight: 500;
  }
  ${Separator} {
    margin: 0 6px;
  }
  ${Title} {
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_1};
    -webkit-font-smoothing: auto;
    margin-bottom: 4px;
  }
  ${PostVote} {
    display: flex;
    margin:0 8px 0 0px;
  }
  ${Preview} {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  ${Preview} img {
    min-width: 64px;
    min-height: 64px;
    width: 64px;
    height: 64px;
    border-radius: 6px;
  }
  @media only screen and (max-width: 780px) {
    ${Preview} {
      align-items: initial;
    }
    ${Main} {
      padding: 12px;
    }
  }
`;

export default PostEmbed;
